export enum ProductCardV2TestIds {
  CARD = 'product-card-v2',
  COLOR_DOT_PREFIX = 'product-card-v2-color-',
}
